import { Outlet } from "react-router-dom";

const AuthLayout = ({}) => {
	return (
		<div className="auth-layout">
			<div className="main">
				<div className="container">
					<Outlet />
				</div>
			</div>
			<div className="side" />
		</div>
	);
};

export default AuthLayout;
